import {
    FETCH_RASPA_ALARM_USAGE_STATISTICS,
    FETCH_RASPA_ALARMS,
    NEW_RASPA_ALARM,
    NEW_RASPA_ALARM_SUCCESS,
    RECEIVE_RASPA_ALARM_USAGE_STATISTICS,
    RECEIVE_RASPA_ALARMS
} from "../actions/actionTypes";

const initalState = {
    isFetchingRaspaAlarms: false,
    RaspaAlarms: [],
    raspaAlarmes: [],
    RaspaAlarmStatistics: {
        countUsage: [],

    }
}

export default (state = initalState, action) => {
    switch(action.type) {
        case FETCH_RASPA_ALARMS:
            return {
                ...state,
                isFetchingRaspaAlarms: true
            }
        case RECEIVE_RASPA_ALARMS:
            return {
                ...state,
                isFetchingRaspaAlarms: false,
                raspaAlarmes: action.payload.alarmes
            }
        case NEW_RASPA_ALARM:
            return {
                ...state,
                isFetchingRaspaAlarms: true
            }
        case NEW_RASPA_ALARM_SUCCESS:
            let newArray = state.RaspaAlarms;
            newArray.push(action.payload);
            return {
                ...state,
                isFetchingRaspaAlarms: false,
                RaspaAlarms: newArray
            }
        case FETCH_RASPA_ALARM_USAGE_STATISTICS:
            return {
                ...state,
                isFetchingRaspaCycleStatistics: true,
                RaspaAlarmStatistics: action.payload
            }
            break;
        case RECEIVE_RASPA_ALARM_USAGE_STATISTICS:
            return {
                ...state,
                isFetchingRaspaCycleStatistics: false,
                RaspaAlarmStatistics: action.payload
            }
            break;
        default:
            return state;
    }
}